import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, MapPin, Phone, Mail } from "lucide-react";
const TocFotosFooter = () => {
  // Use current year directly to prevent hydration mismatch
  const currentYear = new Date().getFullYear();

  return <footer className="bg-[#261E13] text-gray-300 pt-16 pb-8">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 md:gap-16">
          <div>
            <div className="mb-6">
              <img src="/lovable-uploads/24e0e29e-3e10-43db-8be9-1cc4bc18ab2f.png" alt="TocToc Logo" loading="lazy" width="114" height="64" className="h-14 brightness-0 invert-0 " />
            </div>
            
            <p className="mb-6 max-w-md">
              Somos especialistas em fotografia para o mercado imobiliário, 
              ajudando proprietários e corretores a destacarem seus imóveis com imagens profissionais.
            </p>
            
            <div className="flex space-x-4 mb-8">
              <a href="https://www.instagram.com/toctoc.br" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF5605] transition-colors" aria-label="Instagram">
                <Instagram size={20} strokeWidth={1.5} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF5605] transition-colors" aria-label="Facebook">
                <Facebook size={20} strokeWidth={1.5} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF5605] transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} strokeWidth={1.5} />
              </a>
            </div>
          </div>
          
          <div className="grid grid-cols-1 gap-6">
            <div className="flex items-start">
              <MapPin className="h-5 w-5 text-[#FF5605] mr-3 flex-shrink-0 mt-1" />
              <span>
                Avenida Pref. Osmar Cunha, 416 – Centro, Florianópolis/SC
              </span>
            </div>
            
            <div className="flex items-start">
              <Phone className="h-5 w-5 text-[#FF5605] mr-3 flex-shrink-0 mt-0.5" />
              <span>(47) 99736-7396</span>
            </div>
            
            <div className="flex items-start">
              <Mail className="h-5 w-5 text-[#FF5605] mr-3 flex-shrink-0 mt-0.5" />
              <a href="mailto:contato@toctocbr.com" className="hover:text-[#FF5605] transition-colors">
                contato@toctocbr.com
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm">&copy; {currentYear} Toc Toc. Todos os direitos reservados.</p>
          <div className="mt-4 md:mt-0 flex space-x-4 text-sm">
            <Link to="/centraldeajuda" className="hover:text-[#FF5605] transition-colors">
              Central de Ajuda
            </Link>
            <Link to="/termos" className="hover:text-[#FF5605] transition-colors">
              Termos de Serviço
            </Link>
            <Link to="/privacidade" className="hover:text-[#FF5605] transition-colors">
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default TocFotosFooter;